import { RouteConfig } from "../../types/RouteConfig";
import { bacsFileManagementRoute } from "./bacs-file-management/route";

export const financeRoutes: RouteConfig<'with-children'> = {
    name: 'Finance',
    icon: 'mdi mdi-currency-gbp',
    children: [
        bacsFileManagementRoute,
    ]
}